<template>
  <div class="p-8" style="font-family: Sarabun">
    <div v-if="healthRecommendation != null" class="max-w-screen-md mx-auto">
      <img :src="healthRecommendation.poster_url" />
      <h1 class="font-bold text-2xl mt-8">{{ healthRecommendation.title }}</h1>
      <div class="mt-8 relative min-h-screen" v-html="healthRecommendation.content"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  created() {
    this.fetchELearning();
  },
  data() {
    return {
      healthRecommendation: null,
    };
  },
  methods: {
    async fetchELearning() {
      let loader = this.$loading.show();

      try {
        const response = await axios({
          method: "GET",
          url: `${process.env.VUE_APP_API_URL}/health-recommendation/${this.$route.params.healthRecommendationId}`,
        });

        this.healthRecommendation = response.data;

        loader.hide();
      } catch (error) {
        loader.hide();

        console.log(error);
      }
    },
  },
};
</script>

<style>
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
